import { sharedTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

/** Общие фрагменты сценариев: своих сценариев нет, только тексты шагов фрагментов */
export const sharedOnboarding: IOnboardingModule = {
  scenarios: [],
  texts: sharedTexts,
  conditions: {},
}
